import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FieldRichLabel } from './field-rich-label';
const RICOS_THEME = {
  customStyles: {
    p: {
      fontSize: 'var(--wix-forms-formInputValueFont-size)',
      fontFamily: 'var(--wix-forms-formInputValueFont-family)',
      color: 'rgb(var(--wix-forms-formInputValueColor))'
    }
  }
};
export const FieldRichLabelWUT = props => /*#__PURE__*/React.createElement(FieldRichLabel, _extends({
  ricosTheme: RICOS_THEME
}, props));
//# sourceMappingURL=field-rich-label-wut.js.map